/* 常量和通用变量 */

// 加密解密code
export const macCode = 'abc4c960-38dd-1a';
export const partnerCode = 'matelabel';

// 平台版本固定信息
export const defaultPlatformList = () => {
  return [
    {
      equip: 3,
      title: '电脑客户端（PC）',
      downText: '下载win版',
      tag: 'Win7 64位及以上系统，包括Win8/Win10/Win11系统',
      icon: 'https://static.yunlabel.com/assets/images/download/plat-win.png',
      serviceAgreement: 'https://protocol.yunlabel.com/protocol/pc_service.html',
      privacyAgreement: 'https://protocol.yunlabel.com/protocol/pc_privacy.html',
    },
    {
      equip: 1,
      title: '安卓客户端(Android)',
      downText: '下载Android版',
      tag: '向上兼容安卓10.0以上的Android系统',
      icon: 'https://static.yunlabel.com/assets/images/download/plat-and.png',
      serviceAgreement: 'https://protocol.yunlabel.com/protocol/ad_service.html',
      privacyAgreement: 'https://protocol.yunlabel.com/protocol/ad_privacy.html',
    },
    {
      equip: 2,
      title: '苹果客户端（ios）',
      downText: '下载Ios版',
      tag: '向上兼容苹果11以上的ios系统',
      icon: 'https://static.yunlabel.com/assets/images/download/plat-ios.png',
      serviceAgreement: 'https://protocol.yunlabel.com/protocol/ios_service.html',
      privacyAgreement: 'https://protocol.yunlabel.com/protocol/ios_privacy.html',
    },
    {
      equip: 7,
      title: '鸿蒙客户端（Harmony）',
      downText: '下载鸿蒙版',
      tag: '向上兼容鸿蒙7及以上系统',
      icon: 'https://static.yunlabel.com/assets/images/download/plat-hm.png',
      serviceAgreement: 'https://protocol.yunlabel.com/protocol/harmony_service.html',
      privacyAgreement: 'https://protocol.yunlabel.com/protocol/harmony_privacy.html',
    },
    // {
    //   equip: 6,
    //   title: '麒麟客户端（amd）',
    //   tag: '兼容麒麟系统amd',
    //   platIcon: 'https://static.yunlabel.com/assets/images/download/plat-qilin.png'
    // }
  ];
};
